// extracted by mini-css-extract-plugin
module.exports = {"InfoTooltip":"info-tooltip_InfoTooltip__k37ZD","Light":"info-tooltip_Light___lreP","Dark":"info-tooltip_Dark___261n"};